import api from "./axios";

export const createProgram = async (payload) => {
  const response = await api.post("/program", payload);
  return response.data;
};

export const getPrograms = async (companyId, params = {}) => {
  const response = await api.get("/program", {
    params: { company_id: companyId, ...params },
  });
  return response.data;
};

export const getProgramById = async (id) => {
  const response = await api.get(`/program/${id}`);
  return response.data;
};

export const updateProgram = async (id, payload) => {
  const response = await api.put(`/program/${id}`, payload);
  return response.data;
};

export const deleteProgram = async (id, payload = {}) => {
  const response = await api.put(`/program/delete/${id}`, payload);
  return response.data;
};